/* tslint:disable */
/* eslint-disable */
/**
 * Sds Web
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SetSurfacePatternResponse
 */
export interface SetSurfacePatternResponse {
    /**
     * 
     * @type {boolean}
     * @memberof SetSurfacePatternResponse
     */
    success: boolean;
    /**
     * 
     * @type {string}
     * @memberof SetSurfacePatternResponse
     */
    configString?: string | null;
}

export function SetSurfacePatternResponseFromJSON(json: any): SetSurfacePatternResponse {
    return SetSurfacePatternResponseFromJSONTyped(json, false);
}

export function SetSurfacePatternResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SetSurfacePatternResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'success': json['success'],
        'configString': !exists(json, 'configString') ? undefined : json['configString'],
    };
}

export function SetSurfacePatternResponseToJSON(value?: SetSurfacePatternResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'success': value.success,
        'configString': value.configString,
    };
}


